/* globals RULE_CONDITION_OPERATOR_NOT */
function SequencingRollupRuleCondition (Operator, Condition) {
    this.Operator = Operator;
    this.Condition = Condition;
}

SequencingRollupRuleCondition.prototype = {
    toString: function () {
        var ret = "";

        if (this.Operator === RULE_CONDITION_OPERATOR_NOT) {
            ret += "NOT ";
        }

        ret += this.Condition;

        return ret;
    }
};
